import { GridFilterOperator, type GridFilterItem } from '@mui/x-data-grid-pro'
import getGridSingleSelectOperators from './getGridSingleSelectOperators'

let _multiValueOperators: GridFilterOperator[]
export default function getGridMultiValueOperators() {
  if (!_multiValueOperators)
    _multiValueOperators = getGridSingleSelectOperators().map((operator) => ({
      ...operator,
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        // handles single value or array of values
        if (
          !filterItem.value ||
          (Array.isArray(filterItem.value) && !filterItem.value.length)
        )
          return () => true
        let filterValue: string[] = []
        if (filterItem.value.value) {
          filterValue = [filterItem.value.value]
        } else if (
          Array.isArray(filterItem.value) &&
          filterItem.value[0].value
        ) {
          filterValue = filterItem.value.map((v) => v.value)
        } else {
          filterValue = [].concat(filterItem.value).map(String)
        }
        // console.log(filterItem, filterValue)
        return (cellValue?: { value?: any }) => {
          const { value } = cellValue || {}
          if (!Array.isArray(value)) return false

          const strV = value.map(String)
          const match = filterValue.some((v) => strV.includes(v))

          return filterItem.operator === 'not' ? !match : match
        }
      },
    }))
  return _multiValueOperators
}
